import React from 'react'
import { useTranslation } from 'react-i18next'
import { isEmpty, sumBy } from 'lodash'
import moment from 'moment'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import {
  TableRow,
  TableCell,
  withStyles,
  Box,
  Typography
} from '@material-ui/core'
import ActionMenu from '@/components/actionMenu'

import { selectLocalisation } from '@/store/modules/store/selectors'

import { Colors, CommonFonts } from '@/theme'

import { transformFloat } from '@/utils/localisationUtil'
import useStyles from './styles'

const Row = ({ item, onVoidStyle, onUpdateStyle }) => {
  const { t } = useTranslation()
  const classes = useStyles()

  const rowCells = [
    {
      id: 'style_name',
      label: item.name,
    },
    {
      id: 'code',
      label: item.code,
    },
    {
      id: 'gender',
      label: item.gender,
    },
    {
      id: 'tags',
      label: item.tags,
    },
    {
      id: 'variants',
      label: +item.variants?.length,
    },
  ];

  const actionMenus = [
    {
      name: t('styles.update'),
      color: Colors.GRAY_DARK,
      onClick: (data) => {
        onUpdateStyle(data)
      },
    },
    {
      name: t('styles.archive'),
      color: Colors.GRAY_DARK,
      onClick: (data) => {
        onVoidStyle(data)
      },
    },
  ]

  return (
    <TableRow hover style={{ position: 'relative' }}>
      {rowCells.map(rowCell => (
        <StyledTableCell key={rowCell.id}>
          {rowCell.label}
        </StyledTableCell>
      ))}
      <StyledTableCell align='right'>
        <ActionMenu
          data={item}
          actionMenus={actionMenus}
        />
      </StyledTableCell>
    </TableRow>
  )
}

const StyledTableCell = withStyles(() => ({
  root: {
    paddingTop: 30,
    paddingBottom: 30,
    ...CommonFonts.darkFont16,
    fontWeight: 'normal',
    borderBottomColor: Colors.GRAY_BORDER1_25
  },
  head: {
    backgroundColor: '#F3F5F7',
  },
  body: {
    ...CommonFonts.darkFont16
  },
}))(TableCell);

Row.propTypes = {
  item: PropTypes.object,
}

export default Row